import React, {useEffect, useState} from 'react';
import Header from '../../components/Header';
import { Link } from 'react-router-dom';
import Search from '../../components/Search';
import {CategoryDTO} from "../../dtos/category.dto";
import {useRecoilValue} from "recoil";
import {fetchAPIResponseSelector} from "../../store/user.atom";
import {useNavigate} from "react-router";
import {toast} from "react-toastify";

const Categories = () => {
    const [search, setSearch] = useState('');
    const [categories, setCategories] = useState<CategoryDTO[]>([]);
    const navigate = useNavigate();
    const fetchAPIResponse = useRecoilValue(fetchAPIResponseSelector);

    const fetchCategories = async () => {
        const categories = await fetchAPIResponse<CategoryDTO[]>(`/categories?search=${search}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        });

        setCategories(categories.data);
    }

    useEffect(() => {
        fetchCategories();
    }, []);

    useEffect(() => {
        fetchCategories();
    }, [search]);

    const handleEdit = (categoryId: any) => {
        navigate(`/categories/edit/${categoryId}`);
    };

    const handleDelete = async (categoryId: any) => {
        const confirmDelete = window.confirm('Are you sure you want to delete this category?');
        if (confirmDelete) {
            try {
                await fetchAPIResponse(`/categories/${categoryId}`, {
                    method: 'DELETE',
                    headers: {
                        'Accept': 'application/json'
                    }
                });

                fetchCategories();
            } catch (error) {
                toast.error((error as Error).message);
            }
        }
    };

    return (
    <div className='flex flex-col items-center w-full h-full overflow-auto py-10 gap-6'>
        <Header title={'Categories'} button={true} buttonTitle={'Add category'} action={'/categories/add'}/>
            <div className="zbh-card w-11/12 p-8">
            <Search search={search} setSearch={setSearch} placeholderText={'Category'}/>
            <div className='w-full mt-3'>
                  <div className='grid grid-cols-12 gap-4 px-2'>
                      <div className="zbh-th col-span-8">Name</div>
                      <div className="zbh-th col-span-4 text-right">Actions</div>
                  </div>
                  <div className="zbh-tear mt-2" />
                  {categories.map((item) => (
                    <div key={item.id} className='grid grid-cols-12 items-center gap-4 px-2 py-3 border-b border-hair last:border-0 transition hover:bg-canvas/60 rounded-lg'>
                      <div className='col-span-8 flex items-center gap-3 min-w-0'>
                          <img src={item.image} alt={item.name} className='h-12 w-12 shrink-0 rounded-lg object-cover border border-hair' />
                          <p className='truncate text-sm font-medium text-ink'>{item.name}</p>
                      </div>
                      <div className='col-span-4 flex items-center justify-end gap-2'>
                        <button onClick={() => handleEdit(item.id)} className='zbh-btn-ghost px-4 py-1.5 text-xs'>Edit</button>
                        <button onClick={() => handleDelete(item.id)} className='zbh-btn-danger px-4 py-1.5 text-xs'>Delete</button>
                      </div>
                    </div>
                  ))}
            </div>
    </div>
    </div>
    );
};

export default Categories;
